import { BannerData } from '@/models/banner/BannerState.interface';
import { event, payload } from '@conversa/reflex';

export const BannerDataUpdated = event(
  '[ component | Banner ] Data updated',
  payload<BannerData>(),
);

export const BannerClose = event('[ component | Banner ] Closing');
